import { Breadcrumb } from "antd";
import styles from "./ActionSubscriber.module.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import Profile from "../profile/profile";
import { useTranslation } from "react-i18next";
import ActionTabs from "./actionTabs/actionTabs";
import { useLocation } from "react-router-dom";
const ActionSubscriber = () => {
	const [t] = useTranslation("global");
	const location = useLocation();
	return (
		<>
			<div className={`container-main ${styles.container_list}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("corporateSearch.title") }]}
					/>
					<div className="title-page">
						<h3>{t("corporateSearch.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.list_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<Profile Profile={location?.state} state={true} />
								<br />
								<ActionTabs Profile={location?.state} styles={styles} />
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default ActionSubscriber;
